// import React from 'react';
// import ReactDOM from 'react-dom';
// import { BrowserRouter } from 'react-router-dom';
// import { Provider} from 'react-redux';
// import { createStore } from 'redux';

// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import rootReducer from './store';

// const store = createStore(rootReducer);

// ReactDOM.render(
//   <Provider store={store}>
//     <BrowserRouter>
//       <App />
//     </BrowserRouter>
//   </Provider>,
//   document.getElementById('root')
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);


/* global dataLayer */  // Add this line at the top of the file

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';

import App from './App';
import reportWebVitals from './reportWebVitals';
import rootReducer from './store';

// Create the Redux store
const store = createStore(rootReducer);

// Google Analytics Setup (gtag.js)
const TRACKING_ID = 'G-TFL32Z1WWV';  // Replace with your tracking ID

// Add Google Analytics Script to the document
const addGoogleAnalyticsScript = () => {
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${TRACKING_ID}`;
  script.async = true;
  document.head.appendChild(script);

  // Initialize gtag once the script is loaded
  script.onload = () => {
    // Ensure dataLayer is defined
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', TRACKING_ID);
  };
};

// Call the function to load the GA script
addGoogleAnalyticsScript();

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);

// Measure performance if desired
reportWebVitals(console.log);